<template>
    <div class="h-screen overflow-auto">
        <div
            class="relative flex min-h-full bg-neutral-100 dark:bg-gray-900 flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div class="mt-12 sm:mx-auto sm:w-full sm:max-w-[520px] flex flex-col gap-y-3">
                <LogoImage class="self-center h-10" />

                <div class="bg-white dark:bg-gray-800 px-6 py-12 shadow-sm sm:rounded-lg sm:px-12">
                    <slot />
                </div>
            </div>
            <FooterLinks />
        </div>
    </div>
</template>

<script setup>
import FooterLinks from "@/components/layouts/FooterLinks"
</script>
